export const LoginStyles= 
{
   color: { color: "white" },
   headingColor: { color: "#00BBBB" },
};